export default function GetClientUrl() { // este es el cliente que manda mensajes globales


    return "http://localhost:3040/clientsms/" // desarollo && produccion al parecer


    //return "XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX" // produccion

}